import { MutationFunctionOptions } from '@apollo/client';

import useErrorHandledMutation, {
  throwOnlyUnhandledErrors,
} from 'common/hooks/useErrorHandledMutation';

import { sendCompanyInvitationMutation } from './graphql';
import { SendCompanyInvitationVariables } from './types';

const useSendCompanyInvitation = (
  mutationOptions?: MutationFunctionOptions<
    never,
    SendCompanyInvitationVariables
  >,
) => {
  const [sendCompanyInvitationMutator, { loading }] = useErrorHandledMutation<
    never,
    SendCompanyInvitationVariables
  >(sendCompanyInvitationMutation);

  const sendCompanyInvitation = ({
    companyInvitationId,
    companyProfileId,
  }: {
    companyInvitationId?: string;
    companyProfileId?: string;
  }) => {
    if (companyProfileId === undefined) {
      throw new Error('companyProfileId should be defined');
    }
    if (companyInvitationId === undefined) {
      throw new Error('companyInvitationId should be defined');
    }

    return sendCompanyInvitationMutator({
      variables: {
        input: {
          companyInvitationId,
          companyProfileId,
        },
      },
      ...mutationOptions,
    }).catch(throwOnlyUnhandledErrors);
  };

  return {
    loading,
    sendCompanyInvitation,
  };
};

export default useSendCompanyInvitation;
